// extracted by mini-css-extract-plugin
export default {"list":"SidebarItems-module__list--nc0Zo"};